export const downloadInBrowser = (
  fileName: string,
  ...content: BlobPart[]
): void => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(new Blob(content));
  link.download = fileName;
  link.click();
  link.remove();
};
